import { Component, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormsModule,
  ReactiveFormsModule
} from '@angular/forms';
import { HttpErrorResponse } from '@angular/common/http';
import { Router, RouterModule } from '@angular/router';

import { I18NextModule } from 'angular-i18next';
import i18next from 'i18next';
import { MatCardModule } from '@angular/material/card';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';

import { CoreService } from '../../core/services/core.service';
import { StorageService } from '../../core/storage/storage.service';
import { ControlErrors } from 'src/app/shared/utils/generateError';
import { SessionInfo } from '../../shared/model/register.model';
import { UserRegister } from 'src/app/shared/model/register.model';

import { ForgotPasswordModalComponent } from './forgot-password-modal/forgot-password-modal.component';
import { ModalBlockedComponent } from './modal-blocked/modal-blocked.component';
import { ErrorWithGuideComponent } from 'src/app/shared/components/error-with-guide/error-with-guide.component';
import { environment } from 'src/environments/environment';
import { Collective } from 'src/app/shared/model/user.model';
import { FeedbackModalComponent } from 'src/app/shared/components/feedback-modal/feedback-modal.component';

@Component({
  standalone: true,
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  imports: [
    ForgotPasswordModalComponent,
    ModalBlockedComponent,
    ErrorWithGuideComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    I18NextModule,
    MatCardModule,
    MatButtonToggleModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatDialogModule
  ]
})
export class LoginComponent implements AfterViewInit {
  showLayout = true;
  errorMessage = '';
  userRegister: UserRegister = {
    nis: '',
    password: ''
  };
  sessionInfo?: SessionInfo;
  token? = '';
  group = '';
  spinner = false;
  showDownloadGuideLink = false;
  loginErrorMessage: string | null = null;
  restoreErrorMessage: string | null = null;
  showRestoreGuideLink = false;

  userForm: FormGroup = this.fb.group({
    loginType: ['PSS', [Validators.required]],
    nis: ['', [Validators.required]],
    password: ['', Validators.required]
  });

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private coreService: CoreService,
    private storageService: StorageService,
    private controlErrors: ControlErrors,
    public dialog: MatDialog,
    private readonly changeDetectorRef: ChangeDetectorRef
  ) { }

  selectGroup(group: string) {
    this.group = group;
    this.userForm.patchValue({ loginType: group });
  }

  onSubmit() {
    this.userRegister.nis = this.userForm.value.nis || '';
    this.userRegister.password = this.userForm.value.password || '';
    this.storageService.set('userRegister', this.userRegister);
    this.spinner = true;
    this.setUser();
  }

  ngAfterViewInit() {
    this.changeDetectorRef.detectChanges();
  }

  setUser() {
    this.errorMessage = '';
    if (this.userRegister.nis.length === 0) {
      return;
    }
    this.coreService
      .signin(
        this.userRegister.nis,
        this.userRegister.password,
        undefined,
        Collective[this.group as keyof typeof Collective]
      )
      .subscribe({
        next: (res) => {
          this.spinner = false;
          this.sessionInfo = res;
          this.storageService.set('sessionInfo', this.sessionInfo);
          this.router.navigateByUrl('/register/mfa-authentication');
        },
        error: (err: HttpErrorResponse) => {
          this.spinner = false;
          if (err.error.status === 423) {
            this.dialog.open(ModalBlockedComponent, {
              width: '500px',
              data: {
                text: this.controlErrors.generateError(
                  err.error.message,
                  i18next.t('loginBlocked')
                )
              }
            });
          } else if (err.error.status === 412) {
            this.dialog.open(ModalBlockedComponent, {
              width: '500px',
              data: {
                text: this.controlErrors.generateError(
                  err.error.message,
                  i18next.t('loginNoPss')
                )
              }
            });
          } else if (err.error.status === 406 && err.error.message === '5003') {
            this.dialog.open(ModalBlockedComponent, {
              width: '500px',
              data: {
                text: this.controlErrors.generateError(
                  err.error.message,
                  i18next.t('errorNoPhones')
                )
              }
            });
          } else if (err.error.status === 406 && err.error.message === '5005') {
            this.errorMessage = this.controlErrors.generateError(
              err.error.message,
              i18next.t('categoryError')
            );
          } else {
            this.restoreErrorMessage = i18next.t(
              'restoreUserAdditionalMessage'
            );
            this.showRestoreGuideLink = true;

            this.loginErrorMessage = i18next.t('loginAdditionalMessage');
            this.showDownloadGuideLink = true;

            this.errorMessage =
              /* this.controlErrors.generateError(
              err.error.message, */
              i18next.t('genericShortErr');
            /*  ); */
          }
        }
      });
  }

  activeDirectory() {
    window.open(environment.idpUrl, '_self');
  }
  openDialog(): void {
    this.dialog.open(ForgotPasswordModalComponent, {
      width: '360px',
      data: {
        group: this.group
      }
    });
  }

  changeGroup(group: string) {
    if (group === 'EMPLOYEE') return this.activeDirectory();

    this.group = group;
    this.userForm.patchValue({ nis: '', password: '' });
  }

  isEmail() {
    return this.group === 'FAMILY' || this.group === 'OTHERS';
  }

  goBack() {
    this.group = '';
    this.userForm.patchValue({ loginType: 'PSS' });
  }

  onFooterClick(option: string) {
    let documentPath = 'assets/documents/Nota Legal.pdf';
    let name = 'Nota Legal.pdf';
    switch (option) {
      case 'privacy':
        documentPath = 'assets/documents/Política de privacidad.pdf';
        name = 'Política de privacidad.pdf';
        break;
      case 'cookies':
        documentPath = 'assets/documents/Politica de Cookies.pdf';
        name = 'Politica de Cookies.pdf';
        break;
    }
    const a = document.createElement('a');
    a.href = documentPath;
    a.download = name;
    a.click();
  }
  /**
   * Open support text modal
   */
  openSupportModal(): void {
    this.dialog.open(FeedbackModalComponent, {
      width: '600px',
      data: {
        text: i18next.t('supportMsg'),
        close: true,
        theme: 'dark'
      }
    });
  }

  goToRegister(): void {

    if (this.group === 'COMPANY_VO') {

      this.router.navigate(
        ['/company-vo-register'],
        {
          queryParams: {
            group: this.group
          }
        }
      );

      return;
    }

    this.router.navigate(
      ['/register'],
      {
        queryParams: {
          group: this.group
        }
      }
    );
  }
}
